const ET = "America/New_York";

function etParts(now = new Date()): { weekday: number; minutes: number } {
  const parts = new Intl.DateTimeFormat("en-US", {
    timeZone: ET,
    weekday: "short",
    hour: "2-digit",
    minute: "2-digit",
    hourCycle: "h23",
  }).formatToParts(now);

  const value = (type: string): string => parts.find((part) => part.type === type)?.value ?? "";
  const weekdayMap: Record<string, number> = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 };
  const hour = Number(value("hour"));
  const minute = Number(value("minute"));
  return {
    weekday: weekdayMap[value("weekday")] ?? 0,
    minutes: hour * 60 + minute,
  };
}

/** Regular NYSE session: Mon–Fri 09:30–16:00 ET (exclusive of 16:00). */
export function isUsEquityRegularSessionOpen(now = new Date()): boolean {
  const { weekday, minutes } = etParts(now);
  if (weekday === 0 || weekday === 6) return false;
  return minutes >= 9 * 60 + 30 && minutes < 16 * 60;
}

/** Calendar DTE from YYYY-MM-DD expiry to today (ET date). */
export function remainingDte(expirationDate: string, now = new Date()): number | null {
  const exp = String(expirationDate || "").slice(0, 10);
  if (!/^\d{4}-\d{2}-\d{2}$/.test(exp)) return null;
  const todayParts = new Intl.DateTimeFormat("en-CA", {
    timeZone: ET,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).format(now);
  const a = Date.parse(`${todayParts}T12:00:00Z`);
  const b = Date.parse(`${exp}T12:00:00Z`);
  if (!Number.isFinite(a) || !Number.isFinite(b)) return null;
  return Math.round((b - a) / 86_400_000);
}
